import L from 'leaflet';
import locationIconActiveSvg from "../../../../assets/svg/location_pointer_orange.svg"
const locationIconActive = new L.Icon({
    iconUrl: locationIconActiveSvg,
    iconRetinaUrl: locationIconActiveSvg,
    popupAnchor:  [-0, -0],
    iconSize: [28,40],     
});

export default locationIconActive